import { Injectable } from '@angular/core';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';
import { FeedInterface } from 'app/models/feed.model';
import { FieldInterface } from 'app/modules/common/inputs/custom-fields/fields/fields.interface';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';

@Injectable({
  providedIn: 'root',
})
export class FeedDataTransformPost extends DataTransformAbstractPost {
  constructor(protected readonly _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(feed: FeedInterface): FeedInterface {
    if (feed.parent) {
      feed.parent = feed.parent.id as any;
    }
    feed.fields = this.normalizeFields(feed.fields);
    return feed;
  }

  protected normalizeFields(contents: FieldInterface[]): FieldInterface[] {
    if (!Array.isArray(contents)) {
      return contents;
    }
    contents.forEach((feed: FieldInterface) => {
      if (feed.type === 'input' && feed.defaultValue) {
        if (feed.templateOptions.type === 'date') {
          feed.defaultValue = this.normalizeDate(feed.defaultValue.toString());
        }
        if (feed.templateOptions.type === 'month') {
          feed.defaultValue = this.normalizeMonth(feed.defaultValue.toString());
        }
        if (feed.templateOptions.type === 'time') {
          feed.defaultValue = this.normalizeTime(feed.defaultValue.toString());
        }
      }
    });
    return contents;
  }
}
